import { FC, memo } from 'react'
import { MapContainerProps } from 'react-leaflet'
import dynamic from 'next/dynamic'

const Map = dynamic(() => import('./Map'), {
  ssr: false,
})

type Props = MapContainerProps & {
  children?: JSX.Element
}

const AbstractMap: FC<Props> = ({ children, zoom, ...props }) => {
  return (
    <Map zoom={zoom || 18} {...props}>
      {children}
    </Map>
  )
}

export default memo(AbstractMap)
